<script lang="ts">
  import { orgFolder } from "@nrk/origo";
  import type { DraggableImage } from "services/folders/types";
  export let collageImages: DraggableImage[] = [];

  let loadedIds = new Set<string>();
  function onImageLoad(id: string) {
    loadedIds = new Set(loadedIds).add(id);
  }
</script>

<div class="tile-image collage-{collageImages.length}">
  {#each collageImages as image (image.id)}
    <img
      src={image.thumbnail}
      alt=""
      class="collage-img"
      class:loaded={loadedIds.has(image.id)}
      loading="lazy"
      decoding="async"
      on:load={() => onImageLoad(image.id)}
    />
  {:else}
    <div class="tile-placeholder" style="position: relative;">{@html orgFolder}</div>
  {/each}
</div>

<style>
  .tile-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 4rem;
    color: var(--org-color-shade-2);
  }
  .tile-image {
    width: 100%;
    height: 100%;
    display: grid;
    gap: 2px;
    overflow: hidden;
    background-color: var(--org-color-shade-2);
  }
  .collage-img {
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  .collage-img.loaded {
    opacity: 1;
  }
  .empty-placeholder {
    width: 100%;
    height: 100%;
  }
  .collage-0 {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
  .collage-1 {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
  .collage-2 {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }
  .collage-3 {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
  .collage-3 .collage-img:first-child {
    grid-row: 1 / -1;
  }
  .collage-4 {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
  .collage-5 {
    grid-template-columns: 6fr 4fr 4fr;
    grid-template-rows: 2fr 3fr;
  }
  .collage-5 .collage-img:nth-child(1) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }
  .collage-5 .collage-img:nth-child(2) {
    grid-column: 2 / 4;
    grid-row: 1 / 2;
  }
</style>
